import {cva} from 'class-variance-authority';

export const menuItemVariants = cva(
  [
    'relative flex h-11 w-full cursor-default items-center gap-2 rounded-full px-3 py-2',
    'outline-none select-none transition-colors duration-100',
    // cmdk sets data-disabled="true"/"false" (string); Radix sets data-disabled="" (presence).
    // Avoid the presence selector — it matches cmdk's "false" too. Radix opacity is per-component.
    'data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50',
  ].join(' '),
  {
    variants: {
      variant: {
        primary:
          'type-btn-default text-secondary-dark hover:bg-primary-50 hover:text-primary-dark',
        secondary:
          'type-btn-sm text-secondary-dark hover:bg-neutral-light hover:text-secondary-foreground',
      },
      active: {true: ''},
    },
    compoundVariants: [
      {
        variant: 'primary',
        active: true,
        class: 'bg-primary-100 text-primary-dark hover:bg-primary-100',
      },
      {
        variant: 'secondary',
        active: true,
        class:
          'bg-secondary-200 text-secondary-foreground hover:bg-secondary-200',
      },
    ],
    defaultVariants: {variant: 'secondary'},
  }
);
